import {
  useCallback,
  useEffect
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getCompanies, setUserCompany } from '../store';

import { CLINIC_SELECTOR } from '../config';

export function CompanySelector() {
  const companies = useSelector(getCompanies);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onCompanySelect = useCallback(
    (userMeta) => {
      dispatch(setUserCompany(userMeta));
      localStorage.setItem('company-relation', userMeta.company.companyId);
      navigate(CLINIC_SELECTOR);
    },
    [dispatch, navigate]
  );

  useEffect(() => {
    if (companies.length === 1) {
      onCompanySelect(companies[0]);
    }
  }, [companies, onCompanySelect]);
  return (
    <div className="list-group">
      {companies.map((userMeta, index) => (
        <div
          className="col-12 col-md-12"
          key={userMeta.company.companyId}
          aria-current="true"
          onClick={() => onCompanySelect(userMeta)}
          onKeyUp={() => ({})}
          tabIndex={index + 1}
          role="button"
        >
          <div className="basic-pricing card card-hover">
            <div className="card-body">
              <h3>{userMeta.company.businessName}</h3>
              <p className="card-text">{userMeta.company.identificationNumber}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default CompanySelector;
